import {useTranslation} from "react-i18next";
import {
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {CloseRounded} from "@mui/icons-material";
import {useState} from "react";
import {PaOrder} from "../../paOrders/constants/interfaces";

interface AddOrderModalProps {
    open: boolean,
    handleClose: Function,
    append: Function,
    fields?: any,
    orders: PaOrder[]
}

const AddOrderModal = ({open, handleClose, append, fields, orders}: AddOrderModalProps) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'businessAgreement.orderConfiguration'});
    const [selectedOrder, setSelectedOrder] = useState<PaOrder>({
        cig: '',
        cup: '',
        description: '',
        orderId: '',
        id:''
    });

    const changeOrder = (cig: any) => {
        let order = orders.find((o: PaOrder) => o.cig === cig);
        if (order)
            setSelectedOrder({
                cig:order.cig,
                cup:order.cup,
                description:order.description,
                id:order.id,
                orderId:order.orderId
            });
    }

    const addOrder = () => {
        append(selectedOrder);
    }

    const reset = () => {
        setSelectedOrder({
            cig: '',
            cup: '',
            description: '',
            orderId: '',
            id:''
        })
    }


    return (
        <Dialog disableEscapeKeyDown maxWidth={"lg"} fullWidth={true} open={open}
                onClose={() => {
                    reset();
                    return;
                }}>
            <DialogTitle>
                <Typography sx={{paddingLeft: "10px"}} fontWeight={"bold"} color={"primary"}>
                    {t('addOrderModal.title')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        reset();
                        handleClose();
                    }}
                    color={"primary"}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRounded/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <Autocomplete
                            id={'cigNumber'}
                            value={selectedOrder.cig}
                            options={orders.filter((o:PaOrder) => fields.every((f: any) => f.cig !== o.cig) && !o.idBusinessConvention)?.map((o: PaOrder) => o.cig)}
                            onChange={(e: any, value: any) => changeOrder(value)}
                            renderInput={(params) => (
                                <TextField  {...params} fullWidth label={t('cigNumber')}/>
                            )}/>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            disabled
                            value={selectedOrder?.orderId}
                            fullWidth
                            label={t('orderId')}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            disabled
                            value={selectedOrder?.cup}
                            fullWidth
                            label={t('cupNumber')}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            disabled
                            value={selectedOrder?.description}
                            fullWidth
                            label={t('orderDescription')}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{padding: "15px"}}>
                <Button variant={"outlined"} color={"accent"}
                        onClick={() => {
                            reset();
                            handleClose();
                        }}>
                    {t('buttons.cancel')}
                </Button>
                <Button color={"accent"} disabled={selectedOrder === ''} onClick={() => {
                    addOrder();
                    reset();
                    handleClose();
                }}>
                    {t('buttons.add')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddOrderModal;